// Croatian
export const hr = {
    weeklyRewards: 'Tjedne nagrade za',
    days: 'dana',
    hours: 'sati',
    minutes: 'min',
    seconds: 'sek',
    authenticating: 'Autentifikacija',
    verifyWallet: 'Molimo pričekajte dok provjeravamo vaš novčanik',
    authRequired: 'Potrebna autentifikacija',
    authFailed: 'Autentifikacija nije uspjela. Molimo pokušajte ponovno.',
    points: 'Bodovi',
    rank: 'Rang',
    of: 'od',
    players: 'igrača',
    weeklyTopPlayers: 'Najbolji igrači tjedna',
    thisWeekLeaderboard: 'Ljestvica ovog tjedna',
    rankingsReset: 'Rangiranje se resetira svake nedjelje u ponoć UTC',
    yourPoints: 'Vaši bodovi',
    dailyRewardAvailable: 'Dnevna nagrada dostupna!',
    nextClaimAvailable: 'Sljedeće preuzimanje dostupno za:',
    claimDailyReward: 'Preuzmi dnevnu nagradu',
    claiming: 'Preuzimanje...',
    multiplier: 'Množitelj',
    bonusPointsMultiplier: 'Množitelj bonus bodova',
    outOf: 'od',
    loading: 'Učitavanje...',
    errorLoading: 'Greška pri učitavanju',
    noEntries: 'Još nema unosa',
    leaderboard: 'Ljestvica',
    tasks: 'Zadaci',
    rules: 'Pravila',
    profile: 'Profil',
    comingSoon: 'Uskoro...',
    completedTasks: 'Završeni zadaci',
    dailyRewardsClaimed: 'Preuzete dnevne nagrade',
    times: 'puta',
    recentActivity: 'Nedavna aktivnost',
    noRewardsClaimed: 'Još nema preuzetih nagrada',
    dailyReward: 'Dnevna nagrada',
    howItWorks: 'Kako funkcionira',
    welcomeMessage:
        'Dobrodošli u Coinomi Rewards! Zaradite bodove završavanjem raznih zadataka i popnite se na ljestvici.',
    dailyRewardsTitle: 'Dnevne nagrade',
    dailyRewardsRules: [
        'Preuzmite dnevnu nagradu svaka 24 sata',
        'Svako preuzimanje donosi 100 bodova',
        'Bodovi se množe na temelju vašeg množitelja',
    ],
    multiplierBonusesTitle: 'Bonus množitelji',
    multiplierBonusesRules: [
        'Počnite s 1x množiteljem',
        'Povežite Telegram za +10% bonusa',
        'Potvrdite email za +10% bonusa',
        'Bonusi se zbrajaju za maksimalne nagrade',
    ],
    leaderboardTitle: 'Ljestvica',
    leaderboardRules: [
        'Natječite se s drugim igračima',
        'Rangiranje se ažurira u stvarnom vremenu',
        'Najbolji igrači dobivaju posebne nagrade',
    ],
    boostEarningsTitle: 'Povećajte zaradu',
    boostEarningsRules: [
        'Završite izazove za bonus nagrade',
        'Pridružite se našoj Telegram zajednici',
        'Ostanite aktivni za maksimalne nagrade',
    ],
    challenges: 'Izazovi',
    telegramChallenge: 'Telegram izazov',
    emailChallenge: 'Email izazov',
    connectTelegram: 'Poveži s Telegramom',
    shareEmail: 'Podijeli email',
    telegramSuccess: '🎉 Čestitamo! Sada dobivate trajni bonus od 10% na sve nagrade!',
    telegramPrompt: 'Povežite svoj Telegram račun za trajni bonus od 10% na sve nagrade!',
    emailSuccess: '🎉 Čestitamo! Sada dobivate trajni bonus od 10% na sve nagrade!',
    emailPrompt: 'Podijelite svoj email za trajni bonus od 10% na sve nagrade!',
    connectEmail: 'Poveži email',
    cancel: 'Odustani',
    emailPrivacy: 'Vaš email koristit ćemo samo za važne obavijesti i informacije o nagradama.',
    connectYourEmail: 'Povežite svoj email',
    emailBonus: '🎉 Dobijte trajni bonus od 10% na sve nagrade povezivanjem emaila!',
    enterValidEmail: 'Molimo unesite valjanu email adresu',
    emailAddress: 'Email adresa',
    errorSavingEmail: 'Greška pri spremanju emaila. Molimo pokušajte ponovno.',
    claimButton: 'Preuzmi',
    earnedReward: 'Zarađena nagrada',
    rewardValue: '{{amount}} Bodova',
    claimingReward: 'Preuzimanje...',
    claimSuccess: 'Uspješno preuzeto {{amount}} bodova!',
    claimError: 'Greška pri preuzimanju nagrade. Molimo pokušajte ponovno.',
    privacyDisclaimer:
        'Coinomi ne prikuplja osobne podatke; sustav treće strane sigurno upravlja bodovima i društvenim povezivanjem.',
    streakBonus: 'Bonus za niz',
    streakDays: '{{days}}/5 Dana',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Ekstra',
    streakDescription: 'Preuzmite 5 dana zaredom za maksimalni bonus',
    streakToday: 'Danas',
    streakMissed: 'Propušteno',
    streakComplete: 'Završeno',
    streakActive: 'Aktivan niz',
    streakLost: 'Izgubljen niz',
    streakNext: 'Sljedeće',
    home: 'Početna',
    currentStreak: 'Trenutni niz',
    totalClaims: 'Ukupno preuzimanja',
    userStats: 'Vaša statistika',
    referrals: 'Preporuke',
    referralProgram: 'Program preporuka',
    howReferralWorks: 'Kako preporuke funkcioniraju:',
    referralSteps: [
        'Podijelite svoj link za preporuku s prijateljima',
        'Kada se pridruže preko vašeg linka, postaju vaša preporuka',
        'Zaradite bonus bodove za svaku aktivnu preporuku',
        'Pratite svoje preporuke i zaradu ovdje',
    ],
    referralRewards: 'Bodovi za preporuke se dodjeljuju:',
    referralBonuses: [
        '100 bodova kada preporučite nekoga',
        '10% od svih bodova koje preporuka dobije',
    ],
    yourReferralLink: 'Vaš link za preporuke',
    copyToClipboard: 'Kopiraj u međuspremnik',
    linkCopied: 'Link kopiran u međuspremnik!',
    totalReferrals: 'Ukupno preporuka',
    yourReferralCode: 'Vaš kod za preporuke',
    referralCodeCopied: 'Kod za preporuke kopiran!',
    editReferralCode: 'Uredi kod za preporuke',
    editReferralCodeInstructions:
        'Odaberite novi kod za preporuke. Mora imati najmanje 5 znakova i može sadržavati slova i brojeve.',
    newReferralCode: 'Novi kod za preporuke',
    referralCodeRequirements: 'Minimalno 5 znakova, samo slova i brojevi',
    updating: 'Ažuriranje...',
    update: 'Ažuriraj',
    referralCodeTaken: 'Ovaj kod za preporuke je već zauzet',
    haveReferralCode: 'Imate kod za preporuke?',
    enterReferralCodePrompt:
        'Ako vas je netko preporučio, unesite njihov kod ovdje za povezivanje računa.',
    enterReferralCode: 'Unesite kod za preporuke',
    enterReferralCodeInstructions: 'Unesite kod za preporuke koji je podijeljen s vama.',
    referralCode: 'Kod za preporuke',
    referralCodeFormat: 'Samo slova i brojevi',
    submitting: 'Slanje...',
    submit: 'Pošalji',
    enterCode: 'Unesite kod',
    pleaseAddtoken: 'Molimo dodajte token parametar u URL',
    authenticationError: 'Došlo je do greške tijekom autentifikacije',
    noUserFound: 'Korisnik nije pronađen',
    userNotFoundMessage: 'Nije moguće pronaći podatke o korisniku',
    backToHome: 'Natrag na početnu',
    retry: 'Pokušaj ponovno',
    baseMultiplier: 'Osnovni množitelj',
    telegramBonus: 'Telegram bonus',
    referralChallenge: 'Izazov preporuka',
    referralChallengePrompt:
        'Pozovite prijatelje i zaradite bonus bodove! Dobijte 100 bodova za svaku preporuku plus 10% njihove zarade.',
    startReferring: 'Započni s preporukama',
    referralSuccess: '🎉 Čestitamo! Uspješno ste preporučili korisnike i zarađujete bonus bodove!',
    unranked: 'Bez ranga',
    noPlayersYet: 'Budite prvi koji će se pridružiti!',
    shareVia: 'Podijeli putem',
    shareOn: 'Podijeli na {{network}}',
    shareInviteText:
        '🚀 Zarađujem besplatnu kriptovalutu s @CoinomiWallet!\n\nPreuzmite Coinomi s coinomi.com/downloads i unesite moj kod za preporuke {{referralCode}} da biste dobili bonus kada se pridružite #Coinomi Rewards u aplikaciji.',
    yourStatsThisWeek: 'Vaše statistike ovaj tjedan',
    pointsMultiplier: 'Množitelj bodova',
    yourRank: 'Vaš rang',
    rewards: 'Nagrade',
    daily: 'Dnevno',
    weekly: 'Tjedno',
    claimRewards: 'Preuzmi nagrade',
    copy: 'Kopiraj',
    // Twitter Challenge
    twitterChallenge: 'Twitter Izazov',
    connectTwitter: 'Poveži Twitter',
    twitterSuccess: '🎉 Čestitamo! Sada dobivate trajni bonus od 10% na sve nagrade!',
    twitterPrompt:
        'Povežite svoj Twitter račun kako biste dobili trajni bonus od 10% na sve nagrade!',
    pleaseAddUserId: 'Molimo dodajte userId parametar u URL',
    emailChallengePrompt: 'Podijelite svoj email za trajni bonus od 10% na sve nagrade!',
    emailChallengeSuccess: '🎉 Povezano! Sada dobivate trajni bonus od 10% na sve nagrade!',
    followKoalaWalletChallenge: 'Pratite @coinomiWallet na Twitteru kako biste nas podržali!',
    twitterAuthSuccessTitle: 'Twitter uspješno povezan!',
    twitterAuthSuccessMessage:
        'Uspješno ste povezali svoj Twitter račun. Sada možete nastaviti koristiti aplikaciju.',
    continueToApp: 'Nastavi u aplikaciju',
    twitter_like: 'Lajkao tweet',
    twitter_retweet: 'Retweetao tweet',
    disconnect: 'Prekini vezu',
    followCoinomiWallet: 'Pratite @coinomiWallet na Twitteru kako biste nas podržali!',
    connectedBonus: '🎉 Povezano! Sada dobivate trajni bonus od 10% na sve nagrade!',
};
